import { useLightMode } from '@/hooks/useLightMode'

import { Text } from '@chakra-ui/react'

import { TableMenuButton, UserAvatar } from '@hivewatch/dark'

import { formatDateTime } from '@/utils/formatDateTime'

import { WorkflowsColumnIProps, WorkflowsRowDataType } from '../types/types'

interface UseColumnsIProps {
  onArchive: (versionId: string) => void
  isCreatorLoading: boolean
}

// maxWidths sum to TABLE_MAX_WIDTH (1810px): 200 + 1210 + 300 + 100 = 1810
export const useColumns = ({
  isCreatorLoading = false,
  onArchive,
}: UseColumnsIProps): WorkflowsColumnIProps[] => {
  const mode = useLightMode()

  return [
    {
      key: 'createdAt',
      header: 'Created at',
      style: { minWidth: '150px', maxWidth: '200px', flexGrow: 1 },
      sortColumn: 'createdAt',
      cell: (row: WorkflowsRowDataType) => (
        <Text color={`text.secondary.${mode}`} isTruncated>
          {formatDateTime(row.createdAt, 'HH:mm | MM/dd/yyyy')}
        </Text>
      ),
    },
    {
      key: 'incidentType',
      header: 'INC type',
      style: { minWidth: '200px', maxWidth: '1310px', flexGrow: 1 },
      sortColumn: 'incidentType',
      cell: (row: WorkflowsRowDataType) => (
        <Text
          color={
            row.isArchived ? `text.secondary.${mode}` : `text.primary.${mode}`
          }
          isTruncated
        >
          {row.isArchived ? `${row.incidentType} (Archived)` : row.incidentType}
        </Text>
      ),
    },
    {
      key: 'creator',
      header: 'Created By',
      style: { minWidth: '150px', maxWidth: '300px', flexGrow: 1 },
      cell: (row: WorkflowsRowDataType) => (
        <UserAvatar
          colorScheme={mode}
          isLoading={isCreatorLoading}
          name={row.creator}
        />
      ),
    },
    {
      key: 'actions',
      header: '',
      style: { width: '64px', align: 'center' as const },
      cell: (row: WorkflowsRowDataType) =>
        row.isArchived ? null : (
          <TableMenuButton
            colorScheme={mode}
            items={[
              {
                label: 'Archive',
                onClick: () => onArchive(row.id),
              },
            ]}
          />
        ),
    },
  ]
}
